/**
 * AppLoading: what the page shows while a route's code is still arriving.
 * Patrick, Oct 1: "a blank screen for a few seconds." The Suspense fallback
 * and the SSR shell for member routes both rendered an empty cream div; this
 * is the same cream with the AdVenture mark and a thin moving line, so the
 * wait reads as loading instead of broken. Plain markup, no hooks, so it
 * renders identically on the server.
 */
export function AppLoading() {
  return (
    <div className="min-h-screen bg-cream" data-testid="app-loading" aria-busy="true" aria-label="Loading">
      <style>{`
        @keyframes app-loading-sweep { 0% { transform: translateX(-100%); } 100% { transform: translateX(400%); } }
        .app-loading-line { position: fixed; top: 0; left: 0; right: 0; height: 2px; overflow: hidden; background: rgba(5, 5, 41, 0.08); }
        .app-loading-line i { display: block; width: 25%; height: 100%; background: #5832D1; animation: app-loading-sweep 1.1s cubic-bezier(0.4, 0, 0.2, 1) infinite; }
      `}</style>
      <div className="app-loading-line" aria-hidden="true">
        <i />
      </div>
      <div className="container-wide flex items-center h-[72px]">
        <div className="flex items-center gap-3">
          <div className="relative w-8 h-8">
            <div className="absolute top-0 left-0 w-4 h-4 bg-[#5832D1]" />
            <div className="absolute top-0 right-0 w-4 h-4 bg-[#E0433E]" />
            <div className="absolute bottom-0 left-0 w-4 h-4 bg-black" />
          </div>
          <span className="text-2xl tracking-[-0.03em] font-medium" style={{ color: "#050529" }}>
            AdVenture
          </span>
        </div>
      </div>
    </div>
  );
}
